// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/CardCaption/card-caption.sass
// module id = 352
// module chunks = 0